// this comment tells babel to convert jsx to calls to a function called jsx instead of React.createElement
/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import { FONTWEIGHT, FONTSIZE, COLORS } from "../../utils/styles"

const container = css`
  font-weight: ${FONTWEIGHT.REGULAR};
  font-size: ${FONTSIZE.F16};
  color: ${COLORS.C2C2C2C};
  margin: 40px 0;
  line-height: 1.6;
`

export { container }
